import { sectionMappings } from '../../../utils/sectionMappings';

/**
 * Base element patterns for autocomplete
 * These can be combined with suffixes (_1, _2, _main, _secondary, etc.)
 */
export const BASE_ELEMENTS = [
  { value: 'title', description: 'Title' },
  { value: 'subtitle', description: 'Subtitle' },
  { value: 'description', description: 'Description' },
  { value: 'heading', description: 'Heading' },
  { value: 'subheading', description: 'Subheading' },
  { value: 'intro', description: 'Introduction' },
  { value: 'tagline', description: 'Tagline' },
  { value: 'role', description: 'Role/Position' },
  { value: 'button', description: 'Button' },
  { value: 'cta', description: 'Call-to-action' },
  { value: 'link', description: 'Link' },
  { value: 'label', description: 'Label' },
  { value: 'placeholder', description: 'Placeholder' },
  { value: 'caption', description: 'Caption' },
  { value: 'word', description: 'Animated word' },
  { value: 'item', description: 'List item' },
  { value: 'card', description: 'Card content' },
] as const;

/**
 * Available pages for translations
 */
export const PAGE_OPTIONS = [
  { value: 'home', label: 'Home', icon: 'home' },
  { value: 'hub-cases', label: 'Hub Cases', icon: 'layout-grid' },
  { value: 'cases', label: 'Cases', icon: 'folder' },
  { value: 'common', label: 'Common', icon: 'globe' },
] as const;

/**
 * Available sections derived from sectionMappings
 */
export const SECTION_OPTIONS = Object.entries(sectionMappings).map(
  ([key, config]) => ({
    value: key,
    label: config.label,
    icon: config.icon,
    color: config.color,
  })
);

/**
 * Default form data
 */
export const DEFAULT_FORM_DATA = {
  page: 'home',
  section: '',
  element: '',
  textEN: '',
  textFR: '',
} as const;
